import React, { useState } from 'react';
import PatientList from './PatientList';
import StudyViewer from './StudyViewer';
import './TabManager.css';

const TabManager = () => {
  const [tabs, setTabs] = useState([{ id: 'patientList', type: 'list', title: 'Patient List' }]);
  const [activeTabId, setActiveTabId] = useState('patientList');

  const openPatientTab = (patient) => {
    console.log('Opening patient tab:', patient);
    const tabId = `patient-${patient.patientId}`;

    // Check if tab already exists
    const existingTab = tabs.find(tab => tab.id === tabId);

    if (existingTab) {
      // Switch to existing tab
      console.log('Switching to existing tab:', tabId);
      setActiveTabId(tabId);
    } else {
      // Create new tab
      const newTab = {
        id: tabId,
        type: 'viewer',
        title: patient.patientId,
        study: patient
      };
      console.log('Creating new tab:', newTab);
      setTabs([...tabs, newTab]);
      setActiveTabId(tabId);
    }
  };

  const closeTab = (tabId, e) => {
    e?.stopPropagation();

    // Don't close the patient list tab
    if (tabId === 'patientList') return;

    const tabIndex = tabs.findIndex(tab => tab.id === tabId);
    const newTabs = tabs.filter(tab => tab.id !== tabId);

    // If closing active tab, switch to another tab
    if (activeTabId === tabId) {
      if (tabIndex > 0) {
        setActiveTabId(newTabs[tabIndex - 1].id);
      } else if (newTabs.length > 0) {
        setActiveTabId(newTabs[0].id);
      }
    }

    setTabs(newTabs);
  };

  const renderTabContent = (tab) => {
    console.log('Rendering tab content for:', tab);
    if (tab.type === 'list') {
      return <PatientList onPatientSelect={openPatientTab} />;
    } else if (tab.type === 'viewer') {
      return <StudyViewer study={tab.study} onClose={() => closeTab(tab.id)} />;
    }
    return null;
  };

  return (
    <div className="tab-manager">
      {/* Tab Headers */}
      <div className="tab-headers">
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`tab-header ${activeTabId === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTabId(tab.id)}
            onAuxClick={(e) => {
              if (e.button === 1) {
                closeTab(tab.id, e);
              }
            }}
          >
            <span className="tab-title">{tab.title}</span>
            {tab.type !== 'list' && (
              <button
                className="tab-close"
                onClick={(e) => closeTab(tab.id, e)}
                aria-label="Close tab"
              >
                ×
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tab-content-container">
        {tabs.map(tab => (
          <div
            key={tab.id}
            className={`tab-content ${activeTabId === tab.id ? 'active' : ''}`}
          >
            {renderTabContent(tab)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabManager;
